enum customersTypes {
  nursingHomes = 'nursingHomes',
  refuit = 'refuit',
}

const { customerType } = (window as any).config

class customerTypeConfigClass {
  customerType: customersTypes

  constructor(customerType: customersTypes) {
    this.customerType = customerType
  }

  isNursingHome() {
    return customerType === customersTypes.nursingHomes
  }
}

export const customerTypeConfig = new customerTypeConfigClass(customerType)
